var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9484 14.1913L18.9485 14.1913L18.9476 14.1815C18.933 14.0313 18.991 13.8857 19.0934 13.7832L19.0936 13.7833L19.1029 13.7735C19.1803 13.6918 19.2949 13.6396 19.4399 13.6396H20.9375C20.9437 13.6402 20.9477 13.6413 20.9499 13.6421V14.6389C20.949 14.6392 20.9478 14.6394 20.9461 14.6396H19.4999C19.1915 14.6396 18.9655 14.413 18.9484 14.1913Z",
    fill: "#E7E9F1",
    stroke: "#E7E9F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9892 12.6896C17.4892 13.1796 17.2492 13.9096 17.4492 14.6696C17.7092 15.5996 18.6192 16.1896 19.5792 16.1896H20.4492C20.9992 16.1896 21.4492 16.6396 21.4492 17.1896V17.3796C21.4492 19.4496 19.7592 21.1396 17.6892 21.1396H6.20922C4.13922 21.1396 2.44922 19.4496 2.44922 17.3796V10.6496C2.44922 9.41965 3.03922 8.32965 3.94922 7.64965C4.57922 7.16965 5.35922 6.88965 6.20922 6.88965H17.6892C19.7592 6.88965 21.4492 8.57965 21.4492 10.6496V11.0896C21.4492 11.6396 20.9992 12.0896 20.4492 12.0896H19.4292C18.8692 12.0896 18.3592 12.3096 17.9892 12.6896Z",
    fill: "#E7E9F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1991 4.82C16.4691 5.09 16.2391 5.51 15.8591 5.51L8.17908 5.5C7.73908 5.5 7.50908 4.96 7.82908 4.65L9.44908 3.02C10.8191 1.66 13.0391 1.66 14.4091 3.02L16.1591 4.79C16.1691 4.8 16.1891 4.81 16.1991 4.82Z",
    fill: "#E7E9F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletSolid);
export default __webpack_public_path__ + "static/media/wallet-solid.963320910cade08162b7a5beccdaa539.svg";
export { ForwardRef as ReactComponent };